import { abonoIds, cargoIds, ajusteIds } from './plantillasCategorias'
import linkageTypeLabels from './linkageTypeLabels'

export const VINCULACION_TABS = [
  { value: 'abono', label: 'Abono' },
  { value: 'ajuste', label: 'Ajuste' },
  { value: 'cargo', label: 'Cargo' },
  { value: 'cobro-masivo', label: 'Cobro Masivo' },
  { value: 'pago-masivo', label: 'Pago Masivo' }
]

export const isMassiveTab = tab => ['cobro-masivo', 'pago-masivo'].includes(tab)

// folioCredito del movimiento y los ids de tarjetas pertenecen a catálogos distintos.
const plantillaByFolio = {
  0: '5', 1: '6', 2: '3', 3: '7', 4: '8', 5: '14', 6: '9',
  7: '15', 8: '11', 9: '12', 10: '10', 11: '16', 12: '17',
  13: '18', 14: '21', 15: '22', 16: '23', 17: '23', 18: '23',
  19: '24', 20: '24', 21: '24', 22: '25', 23: '30', 24: '31',
  25: '30', 26: '31', 27: '28', 28: '29', 29: '33', 30: '34',
  31: '30', 32: '30', 33: '35', 34: '36', 35: '38', 36: '39'
}

export const getVinculacionTab = row => {
  if (isMassiveTab(row?.linkageType)) return row.linkageType
  if (row?._isDinRevVirtual) return 'ajuste'
  const plantilla = plantillaByFolio[row?.folioCredito]
  if (ajusteIds.includes(plantilla)) return 'ajuste'
  if (abonoIds.includes(plantilla)) return 'abono'
  if (cargoIds.includes(plantilla)) return 'cargo'
  // Préstamo otorgado es una plantilla histórica de cargo.
  if (plantilla === '8') return 'cargo'
  return null
}

const normalizeSearchText = value => String(value).normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase('es')

export const matchesVinculacionFilters = (row, { descripcion = '', montoDesde = '', montoHasta = '' } = {}) => {
  const query = normalizeSearchText(descripcion)
  const text = [row.descripcion, row.razonSocial, row.nombreCuenta, row.contraparte,
    row.clasificacion, row.comprobante, row.numeroFolio, row.rut, row.detectedPeriods,
    row.usuarioClasificador, row.codigoCuenta, row.nombreFolio,
    row._isDinRevVirtual ? 'Cuenta Corriente Agente de Aduana' : linkageTypeLabels[row.folioCredito]]
    .filter(value => value != null).join(' ')
  const normalizedText = normalizeSearchText(text)
  if (query && !query.split(/\s+/).every(word => normalizedText.includes(word))) return false
  const amount = Number(row.montoTotal ?? row.monto ?? 0)
  if (montoDesde !== '' && amount < Number(montoDesde)) return false
  if (montoHasta !== '' && amount > Number(montoHasta)) return false
  return true
}
